module.exports = __webpack_public_path__ + "img/yourStory@2x.428f5fd.jpg";